import {
  OPEN_MODAL,
  CLOSE_MODAL,
} from '../actions/utils';

const defaultState = {
  modal: null,
  id: null,
  status: null,
};

/**
 * Modal reducer logic.
 * @param {Object} state - The state for this reducer in Redux.
 * @param {Object} action - The action which details what to do & what state to update.
 * @returns {Object} - Newly created state object.
 */
export default (state = defaultState, action) => {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        ...state,
        modal: action.payload.modal,
        id: action.payload.id,
        status: action.payload.status,
      };
    case CLOSE_MODAL:
      return {
        ...state,
        modal: null,
        id: null,
      };
    default:
      return state;
  }
};
